/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_This_WeekInputs */

const en_ui_filter_this_week = /** @type {(inputs: Ui_Filter_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this week`)
};

const de_ui_filter_this_week = /** @type {(inputs: Ui_Filter_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diese Woche`)
};

/**
* | output |
* | --- |
* | "this week" |
*
* @param {Ui_Filter_This_WeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_this_week = /** @type {((inputs?: Ui_Filter_This_WeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_This_WeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_this_week(inputs)
	return de_ui_filter_this_week(inputs)
});